import { ComponentProps } from 'react';
import type { IllustrationComponent } from '../Illustration';

// IllustrationDefinition & IllustrationRenderer are a convenient way for a component to accept a Denali illustration,
// along with limited configurable properties, as a prop and render it with specified defaults.

type IllustrationProps = ComponentProps<IllustrationComponent>;

// Properties that are configurable on the IllustrationDefinition type
type IllustrationProperties<P extends keyof IllustrationProps> = Partial<{
  [Prop in P]: IllustrationProps[Prop];
}>;

// Creates a type where the Component is required but all of the specified IllustrationProps are optional
export type IllustrationDefinition<P extends keyof IllustrationProps> = {
  Component: IllustrationComponent;
} & IllustrationProperties<P>;

export type IllustrationRendererProps = {
  illustration: IllustrationDefinition<keyof IllustrationProps>;
  defaults: IllustrationProperties<keyof IllustrationProps>;
};

const IllustrationRenderer = ({ illustration, defaults }: IllustrationRendererProps) => (
  <illustration.Component color={illustration.color || defaults.color} size={illustration.size || defaults.size} />
);

export default IllustrationRenderer;
